﻿var DESKTOP_SEARCH_BTN = '.search__button';
var DESKTOP_SEARCH_FIELD = '.form-control.search__input';

function searchRecords(fieldSelector) {
    var searchText = $(fieldSelector).val().trim();
    if (searchText) {
        var newLocation = "/search-results?indexCatalogue=site-search&searchQuery=" + encodeURIComponent(searchText);
        window.location = newLocation;
    }
}

/* function getSearchResultsPath() {
    var parts = location.pathname.split("/");
    if (parts.length > 0 && parts[0]) return parts[0];
    else throw new Error("Couldn't get search results page location");
} */

(function ($) {
    $(document).ready(function () {
        $(DESKTOP_SEARCH_BTN).on('click', function (e) {
            e.preventDefault();
            searchRecords(DESKTOP_SEARCH_FIELD);
        });
        $(DESKTOP_SEARCH_FIELD).keypress(function (e) {
            var key = e.which;
            if (key === 13) {
                searchRecords(DESKTOP_SEARCH_FIELD);
                return false;
            }
        });
    });
})(jQuery);
